import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { computed, toRefs } from "vue";
var LOADER_TYPES = {
  rectangle: "rectangle",
  circle: "circle"
};
var LOADER_CSS_CLASSES = {
  [LOADER_TYPES.rectangle]: "tw-rounded-xs",
  [LOADER_TYPES.circle]: "tw-rounded-full"
};
var SHIMMER_COLOR = "255,255,255"; //#ffffff
export default /*#__PURE__*/_defineComponent({
  __name: 'ShimmerLoader',
  props: {
    type: {
      type: String,
      default: LOADER_TYPES.rectangle,
      validator(value) {
        return Object.values(LOADER_TYPES).includes(value);
      }
    },
    bgClass: {
      type: String,
      default: "tw-bg-gray-300"
    },
    cssClass: {
      type: String,
      default: ""
    }
    /* shimmerColor: {
        type: String,
        default: SHIMMER_COLOR,
    },*/
  },
  setup(__props) {
    /**
     * "breathing" animation loader with Wikicasa symbol
     */
    var props = __props;
    var {
      type,
      bgClass,
      cssClass
    } = toRefs(props);
    var shimmerStyle = computed(() => {
      return {
        backgroundImage: "linear-gradient(90deg, rgba(".concat(SHIMMER_COLOR, ", 0) 0%, rgba(").concat(SHIMMER_COLOR, ", 0.2) 20%, rgba(").concat(SHIMMER_COLOR, ", 0.5) 60%, rgba(").concat(SHIMMER_COLOR, ", 0))")
      };
    });
    var loaderClass = computed(() => cssClass.value ? cssClass.value : LOADER_CSS_CLASSES[type.value]);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass([_unref(bgClass), loaderClass.value, 'tw-relative tw-overflow-hidden'])
      }, [_createElementVNode("div", {
        class: "shimmer tw-absolute tw-top-0 tw-right-0 tw-bottom-0 tw-left-0",
        style: _normalizeStyle(shimmerStyle.value)
      }, null, 4 /* STYLE */), _renderSlot(_ctx.$slots, "default")], 2 /* CLASS */);
    };
  }
});